import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const InstagramDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {'.insta9-16_svg__cls-1{fill:#212121}.insta9-16_svg__cls-3{fill:none;stroke:#333;stroke-miterlimit:10}'}
      </style>
    </defs>
    <g id="insta9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="insta9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="insta9-16_svg__cls-1"
          d="M6.28 211.87v67.37a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-67.37z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} fill="#fff" />
        <circle className="insta9-16_svg__cls-3" cx={17.34} cy={270.37} r={8.28} />
        <circle className="insta9-16_svg__cls-3" cx={126.26} cy={270.37} r={8.28} />
        <path
          d="M138.06 24.37v213.69A14.92 14.92 0 01123.13 253H21.21a14.92 14.92 0 01-14.93-14.94V24.37z"
          fill="#424242"
        />
        <path
          className="insta9-16_svg__cls-1"
          d="M138 24v-2.36a14.29 14.29 0 00-14.25-14.31h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64V24z"
        />
        <rect className="insta9-16_svg__cls-3" x={32.28} y={261.98} width={79.85} height={16.67} rx={7.25} />
        <circle cx={20.31} cy={43.36} r={6.62} fill="#6f6f6f" />
        <path fill="#eee" d="M10.56 29.97h60.31v1.51H10.56z" />
        <path fill="#9e9e9e" d="M73.47 29.97h60.31v1.51H73.47z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default InstagramDevice916;
